import React from 'react';
import { ListChecks } from 'lucide-react';
import { czDateTime } from '../../utils/upgradesApi';

// "Průběh na místě": the change list as a checklist for the technicians. Ticking is saved at once.
const UpgradeProgressCard = ({ job, form, set, onToggle, busyItem }) => {
  const closed = job.status === 'dokonceno' || job.status === 'zruseno';
  const preparing = job.status === 'navrh' || job.status === 'nabidka_odeslana';
  const done = job.items.filter((i) => i.done).length;
  const pct = job.items.length ? Math.round((done / job.items.length) * 100) : 0;

  return (
    <section className="dlv-card" aria-labelledby="upg-progress">
      <h2 id="upg-progress" className="upg-card-title"><ListChecks size={18} /> Průběh na místě
        <small>{done}/{job.items.length} hotovo</small></h2>
      <div className="upg-progress" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} aria-label="Hotovo"><span style={{ width: `${pct}%` }} /></div>

      {preparing && <p className="dlv-hint" style={{ marginTop: 12 }}>Odškrtávání se zpřístupní po schválení nabídky.</p>}
      {job.items.length === 0 && !preparing && <p className="dlv-hint" style={{ marginTop: 12 }}>Výpis změn je prázdný.</p>}
      <ul style={{ listStyle: 'none', margin: '8px 0 0', padding: 0 }}>
        {job.items.map((item) => (
          <li key={item.id} className={`upg-todo ${item.done ? 'upg-todo--done' : ''}`}>
            <label className="dlv-check" style={{ flex: 1 }}>
              <input type="checkbox" checked={item.done} disabled={closed || preparing || busyItem === item.id} onChange={(e) => onToggle(item.id, e.target.checked)} />
              <span className="dlv-check__box" aria-hidden="true" />
              <span className="upg-todo__text">{item.description}</span>
            </label>
            {item.done && item.done_at && <span className="upg-muted" style={{ fontSize: 12 }}>{czDateTime(item.done_at)}</span>}
          </li>
        ))}
      </ul>

      <div style={{ marginTop: 14 }}>
        <label className="dlv-label" htmlFor="upg-completion">Poznámka z výjezdu / co se skutečně udělalo</label>
        <textarea id="upg-completion" className="dlv-input upg-textarea" value={form.completion_notes} onChange={(e) => set('completion_notes', e.target.value)}
          placeholder="Odchylky od plánu, použité díly navíc, domluva se zákazníkem…" />
      </div>
      {(job.started_at || job.completed_at) && (
        <p className="upg-muted" style={{ fontSize: 13, margin: '10px 0 0' }}>
          {job.started_at && <>Zahájeno {czDateTime(job.started_at)}. </>}{job.completed_at && <>Dokončeno {czDateTime(job.completed_at)}.</>}
        </p>
      )}
    </section>
  );
};

export default UpgradeProgressCard;
